<template>
    <div class="app">
        <div class="img" style="padding-top:3.5rem;padding-bottom:1.0rem">
            <img src="../../../static/img/success-bg.png" alt="">
            <h1  style="padding-top:1.0rem">签约申请提交成功</h1>
        </div>
        <div class="img">
            <img src="../../../static/img/gongzonghao.jpg" alt="" style="padding-bottom:2.25rem">
        </div>
        <div class="code-tips">
            <h3>温馨提示</h3>
            <p>
               请长按二维码关注彭州市家庭医生公众号,快捷发起家庭医生服务.若您有任何签约家庭医生相关的疑问,
               请您联系“{{hospitalName}}”咨询。电话:{{telephone}}
           </p>
       </div>
   </div>
</template>

<script>
    export default{
        data() {
            return {
                hospitalName:'',
                telephone:'',
            }
        },
        created(){
            let params = this.$route.query
            this.hospitalName = params.hospitalName
            this.telephone = params.telephone
        },
    }
</script>

<style lang="scss" scoped>
.app {
    background-color: #EFF3F6;
    .img {
        text-align: center;
        padding: 0.5rem 0;
        background-color: #fff;
        img {
            height: 7.125rem;
        }
        h1 {
            font-size: 18px;
        }
    }
    .code-tips {
        padding: 0 0.5rem;
        h3 {
            height: 2.0rem;
            line-height: 2.0rem;
            text-align: left;
            margin: 0;
            color: #3D3D3D;
        }
        p {
            color: #999A9C;
            word-break: break-all;
            line-height: 1.125rem;
            font-size: 16px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// Review.vue?6f230122